import StudentMainMenuHeader from "@common/header/StudentMainMenuHeader"
import { theme } from "@common/theme/theme"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { studentsService } from "@data/services/studentsService"
import React, { useEffect } from "react"
import { View } from "react-native"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { connect } from "react-redux"
import TodoListScreen from "../activity/todo/TodoListScreen"

const StudentTabsNavigator = (props) => {
    const { route } = props
    const studentId = route.params?.studentId?.toString()
    const anonymous = route.params?.anonymous ?? false
    const withGoBack = route.params?.withGoBack ?? false

    useEffect(() => {
        if (studentId)
            props.apiRequest(studentsService.getStudent, { id: studentId })
    }, [])

    const insets = useSafeAreaInsets()

    return (
        <>
            {/* Hide StudentMainMenuHeader when in parent mode - parent header is shown instead */}
            {!props.isParentMode && (
                <View
                    style={{
                        paddingVertical: 5,
                        paddingTop: insets.top + 5,
                        backgroundColor: theme.colors.white,
                        paddingRight: 10,
                        borderBottomWidth: 1,
                        borderColor: theme.colors.lightMore,
                    }}
                >
                    <StudentMainMenuHeader
                        studentId={studentId}
                        anonymous={anonymous}
                        withGoBack={true}
                    />
                </View>
            )}
            {React.createElement(TodoListScreen, {
                student: props.user?.students?.find(
                    (x) => x?.id?.toString() === studentId
                ),
                anonymous: anonymous,
                withGoBack: withGoBack,
            })}
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        activityTemplates: state.data.staticData?.activity_templates,
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        ),
        isParentMode: state.data.family?.isParentMode,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StudentTabsNavigator)
